import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Chartconstant } from 'src/app/utils/chart.constant';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
// import { SharedComponent } from 'src/app/main/shared/shared.component';
import { GisMapComponent } from 'src/app/main/shared/gis-map/gis-map.component';
import { isNullOrUndefined } from 'util';
import { ObservedWeatherDataService } from '../../side-bar/observed-weather/observed-weather-data.service';
import * as XLSX from 'xlsx';
import { FloodForecastDataService } from '../../side-bar/flood-forecast/flood-forecast-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccuracyPopupDataTableComponent } from '../accuracy-popup-data-table/accuracy-popup-data-table.component';
import { DatePipe } from '@angular/common';
import { SeamlessViewMapConstants } from '../../side-bar/nowcast-dashboard/seamless-view/seamless-map/seamless-view.constants';
// import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rightside-panel',
  templateUrl: './rightside-panel.component.html',
  styleUrls: ['./rightside-panel.component.scss']
})
export class RightsidePanelComponent implements OnInit, OnChanges, OnDestroy {
  // private dtTrigger = new Subject<any>();
  // dtOptions: DataTables.Settings = {};

  @Input() tableDataa: any;
  @Input() stateDataa : any;
  @Input() tableDataMandal: any;
  @Input() chartData: any;
  @Input() formattedChartData: any;
  @Input() mandalDataForDistrict: any;
  @Input() villageDataForMandal: any;
  @Input() component: any;
  @Input() blocksArray: any;
  @Input() blocksArray1: any;
  @Input() blocksArrayHourly: any;
  @Input() formattedChartDataHourly: any;
  @Input() chartDataHourly: any;
  @Input() forecastFile: any;
  @Input() acctabledata: any;
  @Input() maxDate: any;
  @Input() chartData1: any;
  @Input() chartData2: any;
  @Input() chartDataSecond:any;
  @Input() formattedChartDataSecond:any;
  @Input() selectedSource:any
  format: object = { value: 'yyyyMMdd' };
  @Output() districtSelected = new EventEmitter<any>();
  @Output() stateSelected = new EventEmitter<any>();
  @Output() mandalSelected = new EventEmitter<any>();
  @Output() isVillageLevel = new EventEmitter<any>();
  @Output() accuracytableclicked = new EventEmitter<any>();
  @Output() accuracymandalclicked = new EventEmitter<any>();
  @Input() schoolCategoryList:any;
  @Input() schoolCategoryTotalList:any;
  @Input() anganwadiCategoryList:any;
  @Input() healthCareCategoryList:any;
  @Input() healthCareFilteredData:any;
  validation: boolean[] = new Array(5).fill(true);
  tableThrobberDistrict = true;
  selectedDate: object = { required: true };
  tableThrobberMandal = true;
  chartThrobber = true;
  tableThrobber: boolean = true;    // For state-level throbber
  tableThrobber1: boolean = false; // For district-level throbber
  tableThrobber2: boolean = false; // For mandal-level throbber
  accthrobber = false;
  vilthrobber: any;
  show = true;
  showChart = true;
  accEnabled: boolean = false;
  threshold: any;
  sourceList: any;
  columns: string[];
  columns1: string[];
  columns2: any[];
  chartColumns3: any[]
  chartColumnsHourly: any[]
  columns3: string[];
  sourcevalue: any;
  selectedDistrictIndex: any;
  dataSource: any;
  accuracyDataSource: any;
  displayedColumns: any;
  dataSource1: any;
  displayedColumns1: any;
  dataSource2: any;
  dataSource6: any;
  dataSourceHourly:any;
  displayedColumns2: any;
  displayedColumns7: any;
  dataSource3: any;
  villageData: any;
  villageColumns: any;
  villageHeaders: any;
  displayedColumns4: any;
  accuracyHeaders: any;
  componentName: any;
  districtWise: any;
  mandalWise: any;
  tcells: any;
  selectedDistrict: any;
  heading: string;
  header: any;
  millisInSixHours: any;
  admintoggleSubscription: any;
  adminSelected: any;
  forecastLengthSubscription: any;
  forecastLength: any;
  componentUnitMapping: any;
  flagSort = true;
  headerHeight = 50;
  rowHeight = 44;
  temp = 2;
  stateName: string;
  accuracyHeadersColumns: any;
  headerColumns: any;
  headerColumns1: any;
  headerColumns3: any;
  routeChangeDescription: any;
  thresholdMap: object = {};
  locationObj: any;
  detEnsmbl: any;
  layerList: any[];
  otherOptions: {};
  rainfallEnsembleLegend: object;
  selectedComponent: string;
  enableMapInteractionObject = {
    2.5: false,
    15.6: false,
    64.5: false,
    115.6: false
  };
  currentPlayPosition: any;
  currentForecastLength: any;
  thresholdMin: any;
  thresholdMax: any;
  columnTable: any;
  selectedMandal: string | number;
  mandalIndex: any;
  districtCentroid: any;
  mandalCentroid: void;
  districtUUID: any;
  application: string;
  accCurrentlocType: string | number;
  currentlocUUID: any;
  mandalUUIDAcc: any;
  lang: string;
  headerColumns4: any;
  displayedColumns5: any;
  dataSource4: any;
  stateWise: boolean;
  selectedStateIndex: string | number;
  selectedState: any;
  stateCentroid: any;
  stateUUId: any;
  stateUrlId : any;
  tableDataSubscription: any;
  countryWise: boolean;
  stateNameTable: {};
  statedataInfo: any;
  districtNameTable: any
  showHWdownload: boolean = false;
  hourstampdata: any;
  dataSources :any;
  nowcastView: any = 'Admin';
  displayTimestamp: any;
  componentCheck:any = ProjConstants.COMPONENT_CHECK
  applications: any;
  fistChartEnable: boolean = false;
  secondChartEnable: boolean = true;
  thirdChartEnable: boolean = false
  activeTab: string = 'profile';
  levelData: any = 'Country';
  nowcastTimestamp: any;
  displayLevelWiseTable: any = 'No of States';
  displayLevelWiseTableForHeatwave: any = 'No of Districts';
  loading: boolean = true;
  tableThrobberDistricts: boolean = false;
  tableThrobberBlock: boolean = false;
  // selectedSeamlessSource: string;
  selectedSeamlessSource: any;
  seamlessViewSource = SeamlessViewMapConstants.SOURCE_MAPPING_TITLE
  showChartTableToggle = true
  showSchholAlertTable: any;
  showSchholTotalTable: any;
  schoolcatData: any = {};
  totalSchoolCount: any;
  totalAnganwadiCount: any;
  showHealthCareTable: any;
  totalHealthCareCount: any;

  constructor(public chartConstant: Chartconstant, private router: Router, private route: ActivatedRoute,
              public utils: UtilsService, public obj: GisMapComponent, private weatherDataService: ObservedWeatherDataService,
              private FloodForecastData: FloodForecastDataService, private modalService: NgbModal, private datePipe: DatePipe) {
    this.componentUnitMapping = ProjConstants.COMPONENT_UNIT_MAPPING;
    this.millisInSixHours = ProjConstants.MILLS_IN_3HOURS;
    this.adminSelected = true;
    this.tableDataa = {};
    this.stateDataa = {};
    this.mandalDataForDistrict = {};
    this.stateUUId = this.route.snapshot.paramMap.get('id');
    this.selectedComponent = router.url.split('/')[2];
    this.stateName = ProjConstants.IDTOSTATENAMEMAPPING[this.stateUUId];

  }

  closePanel() {
    if (this.obj.dataTabToggleVal) {
      this.obj.dataTabToggle();
      // this.utils.districtClicked.next(null);
    }
  }

  ngOnInit() {

    this.utils.getStateClicked().subscribe(value=>{                                      //fetching state clicked to use click in table
      if(value){
        var index = this.dataSource4.findIndex(obj => obj.uuid==String(value));
      this.getDistrictDataForState(index,'State',value)
      }
    })

     this.utils.getDistrictsClicked().subscribe(value=>{                                 //fetching district clicked to use click in table
    if(value){
      var index = this.dataSource.findIndex(obj => obj.uuid==String(value));
      this.getMandalDataForDistrict(index,'District',value)
    }
  })

    // this.utils.getRadarSourceData().subscribe(source => {
    //   let dataSourcesTimeStamp = source;
    //   this.utils.getTimeStampData().subscribe(data => {
    //     let timeStampData = data;
    //     if(dataSourcesTimeStamp == 'RICKEN'){
    //       this.displayTimestamp = this.formatDateString(timeStampData['RICKEN_NOWCAST']);
    //     }else if(dataSourcesTimeStamp == 'RADAR'){
    //       this.displayTimestamp = this.formatDateString(timeStampData['SIMPLE_RADAR_NOWCAST']);
    //     }else if(dataSourcesTimeStamp == 'IMD RADAR'){
    //       this.displayTimestamp = this.formatDateString(timeStampData['IMD_RADAR_NOWCAST']);
    //     }else if(dataSourcesTimeStamp == 'RADAR+CTT'){
    //       this.displayTimestamp = this.formatDateString(timeStampData['RADAR_CTT_EUMETSAT_NOWCAST']);
    //     }
    //   });
    // })

  this.utils.getCountryNameClicked().subscribe(value=>{                                 //If india is clicked in breadcrumb it will change table view accordingly
    if(value){
      this.changeToDistrictView('Country')
    }
  })
  this.utils.getMandalClicked().subscribe(value=>{                                        //In order to zoom to mandals
    if(value){
      var index = this.dataSource3.findIndex(obj => obj.uuid==String(value));
      this.zoomToMandal(index,'Mandal')
    }
  })
  this.utils.getRadarSourceData().subscribe(source => {
  this.dataSources = source;
  })

    this.lang = localStorage.getItem("lang");
    // this.translate.use(this.lang.match(/en|te|hi/) ? this.lang : 'en');

    this.application = this.router.url.split('/')[1];
    this.applications = this.router.url.split('/')[2];
    this.utils.nowcastView.subscribe(view => {
      if(this.application == 'nowcastweather' && view) {
        this.nowcastView = view
        this.changeToDistrictView('Country');
      }
    })
    this.currentForecastLength = this.router.url.split('/')[3];
    if (this.blocksArray) {
      this.columns = [];
      this.columns3 = [];
      this.columns1 = [];
      this.columns2 = [];
      this.chartColumns3 = [];
      this.chartColumnsHourly = [];
      if (this.adminSelected) {
        this.columns.push('District');
        this.columns3.push('Mandal');
        this.columns1.push('District');
        this.columns1.push('Mandal');
      } else {
        this.columns.push('Basin');
        this.columns3.push('Sub Basin');
        this.columns1.push('Basin');
        this.columns1.push('Sub Basin');
      }
      this.columns2.push(ProjConstants.CHART_DATA_COLUMNS[this.component]);
      this.chartColumns3.push(ProjConstants.CHART_DATA_COLUMNS[this.component]);
      this.chartColumnsHourly.push(ProjConstants.CHART_DATA_COLUMNS[this.component]);
      // console.log(this.columns2,this.blocksArray);

      if (this.currentForecastLength != 'weekly') {
        this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['xAxisLabel'] = {};
        this.blocksArray.forEach((element: string) => {
          this.columns.push(element);
          this.columns3.push(element);
          this.columns1.push(element);
          this.columns2.push(element);
          if (element == '24hr') {

            this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['xAxisLabel'][element] = element;
          } else {
            this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['xAxisLabel'][element] = this.convertTimestampToBlockValue(element);
          }
        });
        if (this.blocksArray1 && Array.isArray(this.blocksArray1)) {
          this.blocksArray1.forEach((element: string) => {
            this.columns.push(element);
            this.columns3.push(element);
            this.columns1.push(element);
            this.columns2.push(element);
            this.chartColumns3.push(element);
            if (element == '24hr') {
              this.chartConstant['chartObjectNowcast']['xAxisLabel'][element] = element;
            } else {
              this.chartConstant['chartObjectNowcast']['xAxisLabel'][element] = this.convertTimestampToBlockValue(element);
            }
          });
        }
        if (this.blocksArrayHourly && Array.isArray(this.blocksArrayHourly)) {
          this.blocksArrayHourly.forEach((element: string) => {
            this.columns.push(element);
            this.columns3.push(element);
            this.columns1.push(element);
            this.columns2.push(element);
            this.chartColumnsHourly.push(element);
            if (element == '24hr') {
              this.chartConstant['chartObjectHourly']['xAxisLabel'][element] = element;
            } else {
              this.chartConstant['chartObjectHourly']['xAxisLabel'][element] = this.convertTimestampToBlockValue(element);
            }
          });
        }
      } else {
        this.chartConstant['chartObjectRainfallWeekly']['xAxisLabel'] = {};
        this.blocksArray.forEach((element: string) => {
          this.columns.push(element);
          this.columns3.push(element);
          this.columns1.push(element);
          this.columns2.push(element);
          if (element == '24hr') {
            this.chartConstant['chartObjectRainfallWeekly']['xAxisLabel'][element] = element;
          } else {
            this.chartConstant['chartObjectRainfallWeekly']['xAxisLabel'][element] = this.convertTimestampToBlockValue(element);
          }
        });
      }
    }
    this.stateWise =true;
    this.districtWise = false;
    this.mandalWise = false;
    this.heading = this.componentName;
    this.header = ProjConstants.CHART_DATA_COLUMNS[this.component];
    // if(this.currentForecastLength!='weekly') {
    //   this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['yAxisTitle'] = 'No of Mandals';
    // } else {
    //   this.chartConstant['chartObjectRainfallWeekly']['yAxisTitle'] = 'No of Mandals';
    // }
    if (this.currentForecastLength != 'weekly') {
      const chartKey = 'chartObject' + this.utils.formatNames(this.component);
      if (!this.chartConstant[chartKey]) {
        this.chartConstant[chartKey] = {}; // Ensure the object exists
      }
      this.chartConstant[chartKey]['yAxisTitle'] = 'No of Mandals';
    } else {
      this.chartConstant['chartObjectRainfallWeekly']['yAxisTitle'] = 'No of Mandals';
    }
    // console.log(this.chartConstant);
    // console.log(this.chartData)
    this.displayedColumns = this.columns;
    this.displayedColumns2 = this.columns2;
    this.displayedColumns7 = this.chartColumns3;
    this.displayedColumns4 = this.columns3;
    if (this.acctabledata && !isNullOrUndefined(this.acctabledata)) {
      this.accuracyHeaders =  this.acctabledata['columns'];
      // this.accuracyDataSource = this.sortAPDistricts(this.acctabledata['data']);
      this.accuracyHeadersColumns = this.acctabledata['tableHeaders'];
      if (this.accuracyHeadersColumns[0]['val'] == 'District') {
        this.accuracyDataSource = this.sortAPDistricts(this.acctabledata['data']);
      } else {
        this.accuracyDataSource = this.sortAsc(this.acctabledata['data'], this.accuracyHeadersColumns[0]['val']);
      }
    }
    if (this.tableDataa) {
      this.tableThrobberDistricts = false;
      // this.tableThrobber1 = false;
      this.tableThrobberDistrict = false;
      this.dataSource = this.tableDataa['data'];
      this.displayedColumns = this.tableDataa['columns'];
      this.headerColumns = this.tableDataa['tableHeaders'];
      if (this.stateName != 'ANDHRA PRADESH') {
        this.sortA(this.dataSource, this.displayedColumns[0][0].val);
      }
      // this.dtTrigger.next();
    }
    if (this.stateDataa) {
      this.loading = false;
      // this.tableThrobber = false;
      // this.tableThrobberDistrict = false;
      this.dataSource4 = this.stateDataa['data'];
      this.displayedColumns5 = this.stateDataa['columns'];
      this.headerColumns4 = this.stateDataa['tableHeaders'];
      if (this.stateName != 'ANDHRA PRADESH') {
        this.sortA(this.dataSource, this.displayedColumns[0][0].val);
      }
      // this.dtTrigger.next();
    }
    if (this.tableDataMandal) {
      this.tableThrobberMandal = false;
      this.dataSource1 = this.tableDataMandal['data'];
      this.displayedColumns1 = this.tableDataMandal['columns'];
      this.headerColumns1 = this.tableDataMandal['tableHeaders'];
      // this.displayedColumns4 = this.columns3;
      this.sortD(this.dataSource1, this.headerColumns1[2].val);

    }
    if (this.formattedChartData) {
      this.chartThrobber = false;
      this.dataSource2 = this.formattedChartData;
    }
    if (this.formattedChartDataSecond) {
      this.chartThrobber = false;
      this.dataSource6 = this.formattedChartDataSecond;
    }
    if (this.formattedChartDataHourly) {
      this.chartThrobber = false;
      this.dataSourceHourly = this.formattedChartDataHourly;
    }
    if (this.mandalDataForDistrict) {
      this.tableThrobberBlock = false;
      this.dataSource3 = this.mandalDataForDistrict['data'];
      this.displayedColumns4 = this.mandalDataForDistrict['columns'];
      this.headerColumns3 = this.mandalDataForDistrict['tableHeaders'];
      this.sortD(this.dataSource3, this.headerColumns3[1].val);
    }
    if (this.villageDataForMandal) {
      this.vilthrobber = false;
      this.villageData = this.villageDataForMandal['data'];
      this.villageColumns = this.villageDataForMandal['columns'];
      this.villageHeaders = this.villageDataForMandal['tableHeaders'];
      this.sortD(this.villageData, this.villageHeaders[1].val);
    }
    if (this.component) {
      this.componentName = this.component;
    }

    this.utils.getNowcastTimestamp().subscribe(async source => {
      // this.nowcastTimestamp = this.formatDateString(Number(source));
      let timestamp = Number(source);
      // Check if the selected source is "RICKEN" and adjust the timestamp
      if (this.selectedSource === 'RICKEN') {
        const oneHourInMilliseconds = 3600000; // 1 hour in milliseconds
        timestamp -= oneHourInMilliseconds; // Subtract 1 hour
      }
      // Format the timestamp into the desired format
      this.nowcastTimestamp = this.formatDateString(timestamp);
    })

    this.router.events.subscribe(e => {
      if (e instanceof NavigationStart) {
        for (const component of ProjConstants.MODULES) {
          let splitted: any;
          splitted = e.url.split('/', 10);
          if (splitted[1].toUpperCase === component) {
            this.heading = component;
          }
        }
      }
    });
    this.utils.districtClicked.subscribe((res: any) => this.locationObj = res);
    this.getSourcelist();
    this.rainfallEnsembleLegend = ProjConstants.RAINFALL_ENSEMBLE_LEGEND_DATA;
    this.utils.getDeterministicOrEnsemble().subscribe(type => {
      this.detEnsmbl = type;
      Object.keys(this.enableMapInteractionObject).forEach(key => {
        this.enableMapInteractionObject[key] = false;
      });
    });
    this.utils.getLayerList().subscribe(data => this.layerList = data);
    this.utils.getOtherOptions().subscribe(options => this.otherOptions = options);
    this.utils.getCurrentPlayPosition().subscribe(value => this.currentPlayPosition = value);
    this.getTimestamp();
  }

  // formatDateString(dateString: string): string {
  //   let year = Number(dateString.substring(0, 4));
  //   let month = Number(dateString.substring(4, 6)) - 1
  //   let day = Number(dateString.substring(6, 8));
  //   let date = new Date(Number(year), Number(month), Number(day));
  //   return this.datePipe.transform(date, 'dd-MMM-yyyy', '+0530') + ' GMT+05:30';
  // }
  formatDateString(timestamp: number): string {
    // console.log(timestamp, "timestamp");
    let date = new Date(timestamp);
    return this.datePipe.transform(date, 'dd-MMM-yyyy hh:mm a', '+0530');
  }

  async getSourcelist() {
    // let sourcelistWithCWC = await this.weatherDataService.getSourceListForComponent(this.componentName).toPromise();
    // this.sourceList = sourcelistWithCWC.filter(function( obj: { key: string; } ) {
    //   return obj.key !== 'CWC';
    // });
  }

  ngOnChanges(change: SimpleChanges) {
    this.lang = localStorage.getItem("lang");
    // this.translate.use(this.lang.match(/en|te|hi/) ? this.lang : 'en');

    this.application = this.router.url.split('/')[1];
    this.currentForecastLength = this.router.url.split('/')[3];
    this.sourcevalue = this.utils.getIdmEcmwfValue();
    this.heading = this.componentName;
    // if(this.sourcevalue == 'ECMWF') {
    //   this.accEnabled = false;
      // this.changeToDistrictView('District');
    // }

    this.admintoggleSubscription = this.utils.getAdminBasinToggle().subscribe(value => {
      if (this.adminSelected != value) {
        this.adminSelected = value;
        this.districtWise = false;
        this.mandalWise = false;
      }
    });
    this.routeChangeDescription = this.route.params.subscribe(data => {
      this.forecastLength = data['time'];
      // this.utils.setForecastLengthChanged(this.forecastLength);
    });
    if (this.blocksArray) {
      this.columns = [];
      this.columns3 = [];
      this.columns1 = [];
      this.columns2 = [];
      this.chartColumns3 = [];
      this.chartColumnsHourly = [];
      if (this.adminSelected) {
        this.columns.push('District');
        this.columns3.push('Mandal');
        this.columns1.push('District');
        this.columns1.push('Mandal');
      } else {
        this.columns.push('Basin');
        this.columns3.push('Sub Basin');
        this.columns1.push('Basin');
        this.columns1.push('Sub Basin');
      }
      this.columns2.push(ProjConstants.CHART_DATA_COLUMNS[this.component]);
      this.chartColumns3.push(ProjConstants.CHART_DATA_COLUMNS[this.component]);
      this.chartColumnsHourly.push(ProjConstants.CHART_DATA_COLUMNS[this.component]);
      // console.log(this.columns2,this.blocksArray);
      if(this.currentForecastLength!='weekly') {
        this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['xAxisLabel'] = {};
        this.blocksArray.forEach((element: string) => {
          this.columns.push(element);
          this.columns3.push(element);
          this.columns1.push(element);
          this.columns2.push(element);
          if (element == '24hr') {
            this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['xAxisLabel'][element] = element;
          } else {
            if(this.application == 'nowcastweather'){
            this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['xAxisLabel'][element] = this.converTimeStampValue(element);
            }
            else if(this.application == 'extremeweather'){
              this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['xAxisLabel'][element] = this.converTimeStampForecastValue(element);
              }
            else{
              this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['xAxisLabel'][element] = this.convertTimestampToBlockValue(element);
            }
          }
        });
        if (this.blocksArray1 && Array.isArray(this.blocksArray1)) {
          this.chartConstant['chartObjectNowcast']['xAxisLabel'] = {};
          this.blocksArray1.forEach((element: string) => {
            this.columns.push(element);
            this.columns3.push(element);
            this.columns1.push(element);
            this.chartColumns3.push(element);
            if (element == '24hr') {
              this.chartConstant['chartObjectNowcast']['xAxisLabel'][element] = element;
            } else {
              if(this.application == 'nowcastweather'){
                this.chartConstant['chartObjectNowcast']['xAxisLabel'][element] = this.converTimeStampValue(element);
              }
              else{
                this.chartConstant['chartObjectNowcast']['xAxisLabel'][element] = this.converTimeStampValue(element);
              }
            }
          });
        }
        if (this.blocksArrayHourly && Array.isArray(this.blocksArrayHourly)) {
          this.chartConstant['chartObjectHourly']['xAxisLabel'] = {};
          this.blocksArrayHourly.forEach((element: string) => {
              this.columns.push(element);
              this.columns3.push(element);
              this.columns1.push(element);
              this.chartColumnsHourly.push(element);
              if (element == '24hr') {
                  this.chartConstant['chartObjectHourly']['xAxisLabel'][element] = element;
              } else {
                  if(this.application == 'nowcastweather'){
                      this.chartConstant['chartObjectHourly']['xAxisLabel'][element] = this.converTimeStampValue(element);
                  } else {
                      this.chartConstant['chartObjectHourly']['xAxisLabel'][element] = this.converTimeStampValue(element);
                  }
              }
          });
      }
      } else {
        this.chartConstant['chartObjectRainfallWeekly']['xAxisLabel'] = {};
        this.blocksArray.forEach((element: string) => {
          this.columns.push(element);
          this.columns3.push(element);
          this.columns1.push(element);
          this.columns2.push(element);
          if (element == '24hr') {
            this.chartConstant['chartObjectRainfallWeekly']['xAxisLabel'][element] = element;
          } else {
            this.chartConstant['chartObjectRainfallWeekly']['xAxisLabel'][element] = this.convertTimestampToBlockValue(element);
          }
        });
      }
    }
    // console.log(this.nowcastView,"nowcast view");
    // if(this.currentForecastLength!='weekly') {
    //   if(this.levelData == 'Country'){
    //     this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['yAxisTitle'] = 'No of States';
    //     this.chartConstant['chartObjectNowcast']['yAxisTitle'] = 'No of States';
    //     this.chartConstant['chartObjectHourly']['yAxisTitle'] = 'No of States';
    //   } else if(this.levelData == 'State'){
    //     this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['yAxisTitle'] = 'No of Districts';
    //     this.chartConstant['chartObjectNowcast']['yAxisTitle'] = 'No of Districts';
    //     this.chartConstant['chartObjectHourly']['yAxisTitle'] = 'No of Districts';
    //   } else{
    //     this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['yAxisTitle'] = 'No of Mandals';
    //     this.chartConstant['chartObjectNowcast']['yAxisTitle'] = 'No of Mandals';
    //     this.chartConstant['chartObjectHourly']['yAxisTitle'] = 'No of Mandals';
    //   }
    // } else {
    //   this.chartConstant['chartObjectRainfallWeekly']['yAxisTitle'] = 'No of Mandals';
    // }
    if (this.nowcastView === 'Admin') {
      // Set default titles for 'Admin' view
      if(this.applications == 'heatwave'){
        if (this.currentForecastLength != 'weekly') {
          if (this.levelData == 'Country') {
            this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['yAxisTitle'] = 'No of Districts';
            this.chartConstant['chartObjectNowcast']['yAxisTitle'] = 'No of Districts';
            this.chartConstant['chartObjectHourly']['yAxisTitle'] = 'No of Districts';
          } else if (this.levelData == 'State') {
            this.displayLevelWiseTableForHeatwave = 'No of Mandals';
            this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['yAxisTitle'] = 'No of Mandals';
            this.chartConstant['chartObjectNowcast']['yAxisTitle'] = 'No of Mandals';
            this.chartConstant['chartObjectHourly']['yAxisTitle'] = 'No of Mandals';
          }
        } else {
          this.chartConstant['chartObjectRainfallWeekly']['yAxisTitle'] = 'No of Mandals';
        }
      }
      else{
        if (this.currentForecastLength != 'weekly') {
          if (this.levelData == 'Country') {
            this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['yAxisTitle'] = 'No of States';
            this.chartConstant['chartObjectNowcast']['yAxisTitle'] = 'No of States';
            this.chartConstant['chartObjectHourly']['yAxisTitle'] = 'No of States';
          } else if (this.levelData == 'State') {
            this.displayLevelWiseTable = 'No of Districts';
            this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['yAxisTitle'] = 'No of Districts';
            this.chartConstant['chartObjectNowcast']['yAxisTitle'] = 'No of Districts';
            this.chartConstant['chartObjectHourly']['yAxisTitle'] = 'No of Districts';
          } else {
            this.displayLevelWiseTable = 'No of Mandals';
            this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['yAxisTitle'] = 'No of Mandals';
            this.chartConstant['chartObjectNowcast']['yAxisTitle'] = 'No of Mandals';
            this.chartConstant['chartObjectHourly']['yAxisTitle'] = 'No of Mandals';
          }
        } else {
          this.chartConstant['chartObjectRainfallWeekly']['yAxisTitle'] = 'No of Mandals';
        }
      }
    } else if (this.nowcastView === 'Cityalerts') {
      // Update titles for 'City Alerts' view
      if (this.currentForecastLength != 'weekly') {
        if (this.levelData == 'Country') {
          this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['yAxisTitle'] = 'No of Cities';
          this.chartConstant['chartObjectNowcast']['yAxisTitle'] = 'No of Cities';
          this.chartConstant['chartObjectHourly']['yAxisTitle'] = 'No of Cities';
        } else {
          this.chartConstant['chartObject' + this.utils.formatNames(this.component)]['yAxisTitle'] = 'No of Mandals';
          this.chartConstant['chartObjectNowcast']['yAxisTitle'] = 'No of Mandals';
          this.chartConstant['chartObjectHourly']['yAxisTitle'] = 'No of Mandals';
        }
      } else {
        this.chartConstant['chartObjectRainfallWeekly']['yAxisTitle'] = 'No of Mandals';
      }
    }
    if (this.acctabledata && !isNullOrUndefined(change.acctabledata)) {
      this.accuracyHeaders =  this.acctabledata['columns'];
      // this.accuracyDataSource = this.sortAPDistricts(this.acctabledata['data']);
      this.accuracyHeadersColumns = this.acctabledata['tableHeaders'];
      if (this.accuracyHeadersColumns[0]['val'] == 'District') {
        this.accuracyDataSource = this.sortAPDistricts(this.acctabledata['data']);
      } else {
        this.accuracyDataSource = this.sortAsc(this.acctabledata['data'], this.accuracyHeadersColumns[0]['val']);
      }
      this.accthrobber = false;
    } else if (this.component != 'RAINFALL') {
      this.accthrobber = false;
    }
    if (this.tableDataa) {
      this.tableThrobberDistricts = false;
      this.tableThrobberDistrict = false;
    // this.tableThrobber1 = false;
      this.dataSource = this.tableDataa['data'];
      this.displayedColumns = this.tableDataa['columns'];
      this.headerColumns = this.tableDataa['tableHeaders'];
      if (this.displayedColumns && this.displayedColumns.length > 0 && this.displayedColumns[0].length > 0) {
        if (this.stateName != 'ANDHRA PRADESH') {
          this.sortA(this.dataSource, this.displayedColumns[0][0].val);
        }
      }
      // this.dtTrigger.next();
    }
    if (this.stateDataa) {
      this.loading = false;
      // this.tableThrobber = false;
      // this.tableThrobberDistrict = false;
      this.dataSource4 = this.stateDataa['data'];
      this.displayedColumns5 = this.stateDataa['columns'];
      this.headerColumns4 = this.stateDataa['tableHeaders'];
      if (this.displayedColumns && this.displayedColumns.length > 0 && this.displayedColumns[0].length > 0) {
        if (this.stateName != 'ANDHRA PRADESH') {
        this.sortA(this.dataSource, this.displayedColumns[0][0].val);
        }

      }
      // this.dtTrigger.next();
    }
    //    console.log(this.tableDataMandal);
    if (this.tableDataMandal && !isNullOrUndefined(change.tableDataMandal)) {
      this.tableThrobberMandal = false;
      this.dataSource1 = this.tableDataMandal['data'];
      this.displayedColumns1 = this.tableDataMandal['columns'];
      this.headerColumns1 = this.tableDataMandal['tableHeaders'];
      // this.displayedColumns4 = this.columns3;
      // console.log(this.headerColumns1);
      this.sortD(this.dataSource1, this.headerColumns1[2].val);

    }
    if (this.formattedChartData && !isNullOrUndefined(change.formattedChartData)) {
      this.chartThrobber = false;
      this.dataSource2 = this.formattedChartData;
      this.displayedColumns2 = this.columns2;
      //      console.log(this.dataSource2);
      //      console.log(this.displayedColumns2)
    }
    if (this.formattedChartDataSecond && !isNullOrUndefined(change.formattedChartDataSecond)) {
      this.chartThrobber = false;
      this.dataSource6 = this.formattedChartDataSecond;
    }
    if (this.formattedChartDataHourly && !isNullOrUndefined(change.formattedChartDataHourly)) {
      this.chartThrobber = false;
      this.dataSourceHourly = this.formattedChartDataHourly;
    }
    if (this.mandalDataForDistrict) {
      this.tableThrobberBlock = false;
    // this.tableThrobber = true;
      this.dataSource3 = this.mandalDataForDistrict['data'];
      let valueHere = [];
      this.dataSource3.forEach(element => {
        Object.keys(element).forEach(val => {
          if(val == 'Mandal') {
            valueHere.push(element[val]['val']);
          }
        })
      });
      this.displayedColumns4 = this.mandalDataForDistrict['columns'];
      this.headerColumns3 = this.mandalDataForDistrict['tableHeaders'];
      this.sortD(this.dataSource3, this.headerColumns3[1].val);
    // this.tableThrobber = false;
    }
    if (!isNullOrUndefined(change.villageDataForMandal) && Object.keys(change.villageDataForMandal.currentValue).length > 0) {
      this.vilthrobber = false;
      this.villageData = this.villageDataForMandal['data'];
      this.villageColumns = this.villageDataForMandal['columns'];
      this.villageHeaders = this.villageDataForMandal['tableHeaders'];
      this.sortD(this.villageData, this.villageHeaders[1].val);
    }
    if (this.component) {
      this.componentName = this.component;
    }
  }

  ngOnDestroy() {
    // this.dtTrigger.unsubscribe();
    this.routeChangeDescription.unsubscribe();
    // this.forecastLengthSubscription.unsubscribe();
    this.admintoggleSubscription.unsubscribe();
  }

  getTimestamp(){
    this.FloodForecastData.getTimestampData().subscribe((response:any)=>{
      if(!isNullOrUndefined(response)) {
        let times = Object.keys(response)
        let firstDate = new Date(Number(times[0]));
        let firstDateLst = firstDate.toString().split(' ').splice(0, 5).join(' ')
        this.hourstampdata = firstDateLst.slice(0, firstDateLst.length - 3)
      }
    })
  }

  onHomeClick(tab:any): void {
    this.fistChartEnable = true;
    this.secondChartEnable = false;
    this.thirdChartEnable =false;
    this.setActiveTab(tab);
  }

  onProfileClick(tab:any): void {
    this.fistChartEnable = false;
    this.secondChartEnable = true;
    this.thirdChartEnable =false;
    this.setActiveTab(tab);
  }

  onContactClick(tab:any): void {
    this.fistChartEnable = false;
    this.secondChartEnable = false;
    this.thirdChartEnable =true;
    this.setActiveTab(tab);
  }

  setActiveTab(tab: any): void {
    this.activeTab = tab;
  }

  convertTimestampToBlockValue(inputts: any) {
    let ts = Number(inputts);
    if (this.forecastLength == '24') {
      // ---------------33435 IMD Block---------------
      // let hoursIncrement = 0;
      // if (this.sourcevalue == 'IMD') {
      //   hoursIncrement = ProjConstants.SOURCE_TIMESTAMP_DIFF.IMD;
      //   ts = ts + hoursIncrement
      // }

      let hours = new Date(ts).getHours();
      let minutes = new Date(ts).getMinutes();
      let string = hours.toString() + ':' + minutes.toString();
      hours = new Date(ts + this.millisInSixHours).getHours();
      minutes = new Date(ts + this.millisInSixHours).getMinutes();
      const string1 = hours.toString() + ':' + minutes.toString();
      console.log(string,string1,"date1234");
      return string.toString() + '-' + string1.toString();
    } else if (this.forecastLength == '10') {
      const date = new Date(ts).toLocaleDateString();
      console.log(date,"date123");
      return date;
    }else if (this.forecastLength == 'weekly') {
      const date = new Date(ts).toLocaleDateString();
      console.log(date,"date12345");
      return date;
    }
    else {
      return inputts;
    }
  }

  converTimeStampValue(timestamp:any){
    var d = new Date(timestamp)
    const hours = d.getHours();
    const minutes = d.getMinutes();

    // Pad minutes with leading zero if needed
    const minutesStr = minutes < 10 ? '0' + minutes : minutes.toString();

    // Format time string as "HH:MM"
    return `${hours}:${minutesStr}`;
    // d.toLocaleDateString()
    // return d.toLocaleTimeString()
  }

  converTimeStampForecastValue(timestamp: any) {
    if(this.forecastLength == '24'){
      const date = new Date(timestamp);
      const startHours = date.getHours();
      const startMinutes = date.getMinutes();
      const endDate = new Date(timestamp + 3 * 60 * 60 * 1000);
      const endHours = endDate.getHours();
      const endMinutes = endDate.getMinutes();
      const formatTime = (hours: number, minutes: number) => {
        const hh = hours < 10 ? '0' + hours : hours;
        const mm = minutes < 10 ? '0' + minutes : minutes;
        return `${hh}:${mm}`;
      };
      const startTimeFormatted = formatTime(startHours, startMinutes);
      const endTimeFormatted = formatTime(endHours, endMinutes);
      const result = `${startTimeFormatted} - ${endTimeFormatted}`;
      return result;
    }else if(this.forecastLength == '10'){
      const date = new Date(timestamp); // Convert timestamp to Date object
      const day = ('0' + date.getDate()).slice(-2); // Get day with leading zero
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // Get month (0-indexed, so add 1) with leading zero
      const year = date.getFullYear(); // Get full year

      return `${day}/${month}/${year}`;
    }
  }

  converSeamLessRainfallTimeStampValue(timestamp: any) {
    let data = this.stateDataa['data'][0][timestamp];
    let formattedDate: any;
    if(data && data.blockLength){
      if (data.blockLength == 'day' || data.blockLength == '24hr') {
        formattedDate = this.formatDate(timestamp);
      } else if (data.blockLength == '3hr') {
        formattedDate = this.formatDateTime(timestamp);
      } else if (data.blockLength == '10min' || data.blockLength == 'hourly') {
        formattedDate = this.formatTime(timestamp);
      }
    }
    return formattedDate;
  }

  converExtremeWeatherTimeStampValue(timestamp: any) {
    let data:any;
    if(this.levelData == 'Country'){
      data = this.stateDataa['data'][0][timestamp];
    }else if(this.levelData == 'State'){
      data = this.tableDataa['data'][0][timestamp];
    }else if(this.levelData == 'District'){
      data = this.mandalDataForDistrict['data'][0][timestamp];
    }
    let formattedDate: any;
    if (data.blockLength == '24hr') {
      formattedDate = '24hr'
    } else if (data.blockLength == '3hr') {
      formattedDate = this.formatTime(timestamp)
    } else if (data.blockLength == 'day') {
      formattedDate = this.formatDate(timestamp)
    } else {
      formattedDate = this.formatTenMinData(timestamp)
    }
    return formattedDate;
  }

  formatDate(timestamp: any): string {
    let date = new Date(Number(timestamp));
    let day = date.getDate().toString().padStart(2, '0');
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  formatDateTime(timestamp: any): string {
    let date = new Date(Number(timestamp));
    let day = date.getDate().toString().padStart(2, '0');
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let year = date.getFullYear();
    let hours = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  formatTime(timestamp: any): string {
    let date = new Date(Number(timestamp));
    let hours = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  formatTenMinData(timestamp: any) {
    const date = new Date(timestamp);
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'P.M.' : 'A.M.';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
  const formattedTime = `${hours}:${formattedMinutes} ${ampm}`;
  return formattedTime;
  }

  onButtonClick() {
    this.show = !this.show;
    if(!this.threshold) {
      this.threshold = '';
    } else {
      setTimeout(() => {
        this.updateThreshold();
      }, 500);
    }
    if (this.stateName != 'ANDHRA PRADESH') {
      this.sortA(this.dataSource, this.displayedColumns[0][0].val);
    }
    this.sortD(this.dataSource1, this.headerColumns1[2].val);
    this.utils.thresholdMap.next({});
    this.obj.resetLayerStyle();
  }

  onButtonClick1() {
    this.showChart = !this.showChart;
  }

  updateThreshold() {
    // this.threshold = 8;
    this.tcells = document.getElementsByName('tcell');
    // this.tcells = document.getElementsByClassName('datatable-body-cell sort-active');
    for (const i of this.tcells) {
      i.classList.remove(ProjConstants.THRESHOLD_COLOR);
    }
    for (const i of this.tcells) {
      if (this.component !== 'TEMPERATURE' && Number(i.textContent) >= this.threshold) {
        i.classList.add(ProjConstants.THRESHOLD_COLOR);
      } else if (this.component === 'TEMPERATURE') {
        if (Number(i.textContent.toString().split(' ')[0]) >= this.threshold) {
          i.classList.add(ProjConstants.THRESHOLD_COLOR);
        }
      }
    }
    this.createThresholdMap();
  }

  createThresholdMap() {
    this.thresholdMap = {};
    const appType = this.router.url.split('/')[1];
    const timeType = parseInt(this.router.url.split('/')[3], 10);
    if (appType === 'extremeweather') {
      if (timeType === 24) {
        if (this.componentName === 'WINDSPEED') {
          if (this.show) {
            if (isNullOrUndefined(this.locationObj) || this.locationObj.loc === 'ANDHRA PRADESH' || this.locationObj.locType === 'State') {
              if (!this.adminSelected) {
                this.thresholdMap['type'] = 'Basin View';
              } else {
                this.thresholdMap['type'] = 'District View';
              }
              Object.keys(this.dataSource).forEach((key: any) => {
                this.thresholdMap[this.dataSource[key].uuid] = [];
                for (let i = 0; i <= 3; ++i) {
                  if (Number(this.dataSource[key][(this.obj.initialCounter + (i * 21600000))].val.split(' ')[0]) >= this.threshold) {
                    this.thresholdMap[this.dataSource[key].uuid].push(1);
                  } else {
                    this.thresholdMap[this.dataSource[key].uuid].push(0);
                  }
                }
              });
            } else if (this.locationObj.locType === 'District' || this.locationObj.locType === 'Basin') {
              if (!this.adminSelected) {
                this.thresholdMap['type'] = 'Sub-basin View';
              } else {
                this.thresholdMap['type'] = 'Mandal View';
              }
              Object.keys(this.dataSource3).forEach((key: any) => {
                this.thresholdMap[this.dataSource3[key].uuid] = [];
                for (let i = 0; i <= 3; ++i) {
                  if (Number(this.dataSource3[key][(this.obj.initialCounter + (i * 21600000))].val.split(' ')[0]) >= this.threshold) {
                    this.thresholdMap[this.dataSource3[key].uuid].push(1);
                  } else {
                    this.thresholdMap[this.dataSource3[key].uuid].push(0);
                  }
                }
              });
            }
          } else {
            if (!this.adminSelected) {
              this.thresholdMap['type'] = 'Sub-basin View';
            } else {
              this.thresholdMap['type'] = 'Mandal View';
            }
            Object.keys(this.dataSource1).forEach((key: any) => {
              this.thresholdMap[this.dataSource1[key].uuid] = [];
              for (let i = 0; i <= 3; ++i) {
                if (Number(this.dataSource1[key][(this.obj.initialCounter + (i * 21600000))].val.split(' ')[0]) >= this.threshold) {
                  this.thresholdMap[this.dataSource1[key].uuid].push(1);
                } else {
                  this.thresholdMap[this.dataSource1[key].uuid].push(0);
                }
              }
            });
          }
        } else if (this.componentName === 'RAINFALL' || this.componentName === 'TEMPERATURE' || this.componentName === 'HUMIDITY') {
          if (this.show) {
            if (isNullOrUndefined(this.locationObj) || this.locationObj.loc === 'ANDHRA PRADESH' || this.locationObj.locType === 'State') {
              if (!this.adminSelected) {
                this.thresholdMap['type'] = 'Basin View';
              } else {
                this.thresholdMap['type'] = 'District View';
              }
              Object.keys(this.dataSource).forEach((key: any) => {
                this.thresholdMap[this.dataSource[key].uuid] = [];
                for (let i = 0; i <= 3; ++i) {
                  if (Number(this.dataSource[key][(this.obj.initialCounter + (i * 21600000))].val.split(' ')[0]) >= this.threshold) {
                    this.thresholdMap[this.dataSource[key].uuid].push(1);
                  } else {
                    this.thresholdMap[this.dataSource[key].uuid].push(0);
                  }
                }
                if (Number(this.dataSource[key]['24hr'].val.split(' ')[0]) >= this.threshold) {
                  this.thresholdMap[this.dataSource[key].uuid].push(1);
                } else {
                  this.thresholdMap[this.dataSource[key].uuid].push(0);
                }
              });
            } else if (this.locationObj.locType === 'District' || this.locationObj.locType === 'Basin') {
              if (!this.adminSelected) {
                this.thresholdMap['type'] = 'Sub-basin View';
              } else {
                this.thresholdMap['type'] = 'Mandal View';
              }
              Object.keys(this.dataSource3).forEach((key: any) => {
                this.thresholdMap[this.dataSource3[key].uuid] = [];
                for (let i = 0; i <= 3; ++i) {
                  if (Number(this.dataSource3[key][(this.obj.initialCounter + (i * 21600000))].val.split(' ')[0]) >= this.threshold) {
                    this.thresholdMap[this.dataSource3[key].uuid].push(1);
                  } else {
                    this.thresholdMap[this.dataSource3[key].uuid].push(0);
                  }
                }
                if (Number(this.dataSource3[key]['24hr'].val.split(' ')[0]) >= this.threshold) {
                  this.thresholdMap[this.dataSource3[key].uuid].push(1);
                } else {
                  this.thresholdMap[this.dataSource3[key].uuid].push(0);
                }
              });
            }
          } else {
            if (!this.adminSelected) {
              this.thresholdMap['type'] = 'Sub-basin View';
            } else {
              this.thresholdMap['type'] = 'Mandal View';
            }
            Object.keys(this.dataSource1).forEach((key: any) => {
              this.thresholdMap[this.dataSource1[key].uuid] = [];
              for (let i = 0; i <= 3; ++i) {
                if (Number(this.dataSource1[key][(this.obj.initialCounter + (i * 21600000))].val.split(' ')[0]) >= this.threshold) {
                  this.thresholdMap[this.dataSource1[key].uuid].push(1);
                } else {
                  this.thresholdMap[this.dataSource1[key].uuid].push(0);
                }
              }
              if (Number(this.dataSource1[key]['24hr'].val.split(' ')[0]) >= this.threshold) {
                this.thresholdMap[this.dataSource1[key].uuid].push(1);
              } else {
                this.thresholdMap[this.dataSource1[key].uuid].push(0);
              }
            });
          }
        }
      } else if (timeType === 10) {
        if (this.componentName === 'WINDSPEED') {
          let counter = this.obj.initialCounter;
          const currDate = new Date();
          const date1 = new Date();
          date1.setHours(5, 30, 0);
          const date2 = new Date();
          date2.setHours(11, 30, 0);
          const date3 = new Date();
          date3.setHours(17, 30, 0);
          const date4 = new Date();
          date4.setHours(23, 30, 0);
          if (currDate >= date1 && currDate < date2) {
            counter -= (21600000 * 0);
          } else if (currDate >= date2 && currDate < date3) {
            counter -= (21600000 * 1);
          } else if (currDate >= date3 && currDate < date4) {
            counter -= (21600000 * 2);
          } else {
            counter -= (21600000 * 3);
          }
          if (this.show) {
            if (isNullOrUndefined(this.locationObj) || this.locationObj.loc === 'ANDHRA PRADESH' || this.locationObj.locType === 'State') {
              if (!this.adminSelected) {
                this.thresholdMap['type'] = 'Basin View';
              } else {
                this.thresholdMap['type'] = 'District View';
              }
              Object.keys(this.dataSource).forEach((key: any) => {
                this.thresholdMap[this.dataSource[key].uuid] = [];
                for (let i = 0; i <= 6; ++i) {
                  if (Number(this.dataSource[key][(counter + (i * 86400000))].val.split(' ')[0]) >= this.threshold) {
                    this.thresholdMap[this.dataSource[key].uuid].push(1);
                  } else {
                    this.thresholdMap[this.dataSource[key].uuid].push(0);
                  }
                }
              });
            } else if (this.locationObj.locType === 'District' || this.locationObj.locType === 'Basin') {
              if (!this.adminSelected) {
                this.thresholdMap['type'] = 'Sub-basin View';
              } else {
                this.thresholdMap['type'] = 'Mandal View';
              }
              Object.keys(this.dataSource3).forEach((key: any) => {
                this.thresholdMap[this.dataSource3[key].uuid] = [];
                for (let i = 0; i <= 6; ++i) {
                  if (Number(this.dataSource3[key][(counter + (i * 86400000))].val.split(' ')[0]) >= this.threshold) {
                    this.thresholdMap[this.dataSource3[key].uuid].push(1);
                  } else {
                    this.thresholdMap[this.dataSource3[key].uuid].push(0);
                  }
                }
              });
            }
          } else {
            if (!this.adminSelected) {
              this.thresholdMap['type'] = 'Sub-basin View';
            } else {
              this.thresholdMap['type'] = 'Mandal View';
            }
            Object.keys(this.dataSource1).forEach((key: any) => {
              this.thresholdMap[this.dataSource1[key].uuid] = [];
              for (let i = 0; i <= 6; ++i) {
                if (Number(this.dataSource1[key][(counter + (i * 86400000))].val.split(' ')[0]) >= this.threshold) {
                  this.thresholdMap[this.dataSource1[key].uuid].push(1);
                } else {
                  this.thresholdMap[this.dataSource1[key].uuid].push(0);
                }
              }
            });
          }
        } else if (this.componentName === 'RAINFALL' || this.componentName === 'TEMPERATURE' || this.componentName === 'HUMIDITY') {
          if (this.show) {
            if (isNullOrUndefined(this.locationObj) || this.locationObj.loc === 'ANDHRA PRADESH' || this.locationObj.locType === 'State') {
              if (!this.adminSelected) {
                this.thresholdMap['type'] = 'Basin View';
              } else {
                this.thresholdMap['type'] = 'District View';
              }
              Object.keys(this.dataSource).forEach((key: any) => {
                this.thresholdMap[this.dataSource[key].uuid] = [];
                for (let i = 0; i <= 6; ++i) {
                  if (Number(this.dataSource[key][(this.obj.initialCounter + (i * 86400000))].val.split(' ')[0]) >= this.threshold) {
                    this.thresholdMap[this.dataSource[key].uuid].push(1);
                  } else {
                    this.thresholdMap[this.dataSource[key].uuid].push(0);
                  }
                }
              });
            } else if (this.locationObj.locType === 'District' || this.locationObj.locType === 'Basin') {
              if (!this.adminSelected) {
                this.thresholdMap['type'] = 'Sub-basin View';
              } else {
                this.thresholdMap['type'] = 'Mandal View';
              }
              Object.keys(this.dataSource3).forEach((key: any) => {
                this.thresholdMap[this.dataSource3[key].uuid] = [];
                for (let i = 0; i <= 6; ++i) {
                  if (Number(this.dataSource3[key][(this.obj.initialCounter + (i * 86400000))].val.split(' ')[0]) >= this.threshold) {
                    this.thresholdMap[this.dataSource3[key].uuid].push(1);
                  } else {
                    this.thresholdMap[this.dataSource3[key].uuid].push(0);
                  }
                }
              });
            }
          } else {
            if (!this.adminSelected) {
              this.thresholdMap['type'] = 'Sub-basin View';
            } else {
              this.thresholdMap['type'] = 'Mandal View';
            }
            Object.keys(this.dataSource1).forEach((key: any) => {
              this.thresholdMap[this.dataSource1[key].uuid] = [];
              for (let i = 0; i <= 6; ++i) {
                if (Number(this.dataSource1[key][(this.obj.initialCounter + (i * 86400000))].val.split(' ')[0]) >= this.threshold) {
                  this.thresholdMap[this.dataSource1[key].uuid].push(1);
                } else {
                  this.thresholdMap[this.dataSource1[key].uuid].push(0);
                }
              }
            });
          }
        }
      }
      this.utils.thresholdMap.next(this.thresholdMap);
      this.obj.changeLayerStyleforThreshold(this.componentName.toLowerCase());
    }
  }

  resetThreshold() {
    this.threshold = '';
    this.tcells = document.getElementsByName('tcell');
    for (const i of this.tcells) {
      i.classList.remove(ProjConstants.THRESHOLD_COLOR);
    }
    this.utils.thresholdMap.next({});
    this.obj.resetLayerStyle();
  }

  zoomToDistrict(locType: string | number) {
    const districtName = this.selectedDistrictIndex;
    const mapDistrict = {
      loc: this.dataSource[districtName][locType].val,
      centroid: this.dataSource[districtName]['centroid']
    };
    mapDistrict['locType'] = locType;
    this.utils.districtClicked.next(mapDistrict);
  }
  zoomToState(locType: string | number) {
    const stateName = this.selectedStateIndex;
    const mapDistrict = {
      loc: stateName,
      centroid: this.dataSource[stateName]['centroid'],
      zoomLevel : 5
    };
    mapDistrict['locType'] = locType;
    this.utils.districtClicked.next(mapDistrict);

  }

  zoomToVillage(locType: string | number) {
    const districtName = this.mandalIndex;
    let mapDistrict;
    if(this.accEnabled) {
      mapDistrict = {
        loc: this.selectedMandal,
        centroid: this.mandalUUIDAcc
      };
    } else {
      mapDistrict = {
        loc: this.villageData[districtName][locType].val,
        centroid: this.mandalCentroid
      };
    }
    mapDistrict['locType'] = locType;
    this.utils.districtClicked.next(mapDistrict);
  }

  getMandalDataForDistrict(districtName: string | number, locType: string | number, districtUUID: any) {
    this.tableThrobberBlock = true;
    this.chartThrobber = true;
    // this.tableThrobber = true;
    // this.tableThrobber1 = false;
    // this.tableThrobber2 = false;
    this.threshold = '';
    this.levelData = locType;
    this.districtWise = this.nowcastView == 'Admin' ? false : true;
    this.mandalWise = this.nowcastView == 'Admin' ? true : false;
    this.selectedDistrictIndex = districtName;
    this.selectedDistrict = this.dataSource[districtName][locType].val;
    this.districtCentroid = this.dataSource[districtName]['centroid'];
    this.districtUUID = districtUUID;
    this.isVillageLevel.emit({
      village: false
    });
    this.districtSelected.emit({
      district: this.selectedDistrict,
      districtUUID : districtUUID,
      mandal: true
    });
    this.districtNameTable={
      district: this.selectedDistrict,
      districtUUID : districtUUID,
      centroid : this.districtCentroid
    }
    this.utils.setDistrictClickedNameTable(this.districtNameTable)
    const mapDistrict = {
      loc: this.dataSource[districtName][locType].val,
      centroid: this.dataSource[districtName]['centroid'],
      uuid: this.districtUUID
    };
    mapDistrict['locType'] = locType;
    this.utils.districtClicked.next(mapDistrict);
    this.utils.setDistrictClicked(mapDistrict);
    this.utils.setDistrictClickedUUID(districtUUID)
    this.utils.thresholdMap.next({});
    if(this.applications == 'heatwave' || this.applications == 'coldwave') {
      this.chartData = [];
      this.chartThrobber = false
      this.showChartTableToggle = false
    }
    // this.obj.resetLayerStyle();
  }
  getDistrictDataForState(stateName: string | number, locType: string | number, stateUUID: any) {
    this.tableThrobberDistricts = true;
    this.chartThrobber = true;
    // this.tableThrobber = false;
    // this.tableThrobber1 = true;
    this.districtWise = true;
    this.mandalWise = false;
    this.stateWise=false;
    this.levelData = locType;
    this.selectedStateIndex = stateName;
    this.selectedState = this.dataSource4[stateName][locType].val;
    this.stateName = this.selectedState;
    this.stateCentroid = this.dataSource4[stateName]['centroid'];
    this.stateUUId = stateUUID;
    this.isVillageLevel.emit({
      village: false
    });
    this.stateSelected.emit({
      // state: this.selectedState,
      stateUUID:this.stateUUId,
      state: this.selectedState,
      centroid : this.stateCentroid,
      district: true
    });
    this.stateNameTable={
      state: this.selectedState,
      centroid : this.stateCentroid,
      stateUUID:this.stateUUId,
    }
    this.utils.setStateClickedNameTable(this.stateNameTable)
    const mapDistrict = {
      loc: this.dataSource4[stateName][locType].val,
      centroid: this.dataSource4[stateName]['centroid'],
      zoomLevel : 7,
      uuid : this.stateUUId
    };
    mapDistrict['locType'] = locType;
    this.utils.districtClicked.next(mapDistrict); //implement zoom in and zoom out
    this.utils.setDistrictClicked(mapDistrict);
    // this.utils.thresholdMap.next({});
    // this.utils.setStateClicked(this.stateUUId)
    // this.obj.resetLayerStyle();
    this.showHWdownload =true;
    let obj:any={};
    obj['download']=true;
    obj['uuid']=stateUUID;
    this.utils.setShowDownload(obj);
    this.utils.schoolCheckBoxClicked.subscribe(data => {
      this.showSchholTotalTable = '';
      this.showSchholAlertTable = data;
      if (this.schoolCategoryTotalList) {
        const values: number[] = Object.values(this.schoolCategoryTotalList) as number[];
        this.totalSchoolCount = values.reduce((sum, val) => sum + val, 0);
      } else {
        this.totalSchoolCount = 0;
      }
    });
    this.utils.CheckBoxAngaClicked.subscribe(data => {
      this.showSchholAlertTable = '';
      this.showSchholTotalTable = data;
      if (this.anganwadiCategoryList) {
        const values: number[] = Object.values(this.anganwadiCategoryList) as number[];
        this.totalAnganwadiCount = values.reduce((sum, val) => sum + val, 0);
      } else {
        this.totalAnganwadiCount = 0;
      }
    });

    this.utils.CheckBoxHealthCareClicked.subscribe(data => {
      // this.showSchholAlertTable = '';
      this.showHealthCareTable = data;
      if (this.healthCareCategoryList) {
        const values: number[] = Object.values(this.healthCareCategoryList) as number[];
        this.totalHealthCareCount = values.reduce((sum, val) => sum + val, 0);
      } else {
        this.totalHealthCareCount = 0;
      }
    });
  }



  getVillageDataForMandal(mandalIndex: string | number, locType: string | number, mandalName: string | number, mandalUUID: any) {
    this.vilthrobber = true;
    this.mandalIndex = mandalIndex;
    this.districtWise = true;
    this.mandalWise = true;
    this.selectedMandal = mandalName;
    this.mandalCentroid = this.dataSource3[mandalIndex]['centroid']
    this.isVillageLevel.emit({
      village: true,
      mandalUUID
    });
    this.mandalSelected.emit({
      mandal: mandalName,
      mandalUUID
    });
    const mapMandal = {
      loc: this.dataSource3[mandalIndex][locType].val,
      centroid: this.dataSource3[mandalIndex]['centroid'],
      zoomLevel : 9
    }
    mapMandal['locType'] = locType;
    this.utils.districtClicked.next(mapMandal);
  }

  getMandalDataForAccuracy(districtName: string | number, locType: string | number) {
    // console.log(districtName, this.accuracyDataSource);
    let currentLoc;
    this.threshold = '';
    this.districtWise = true;
    this.selectedDistrictIndex = districtName;
    this.accCurrentlocType = locType;
    if (locType == 'District') {
      this.selectedDistrict = this.accuracyDataSource[districtName][locType].val;
      this.currentlocUUID = this.accuracyDataSource[districtName][locType].id;
      this.districtCentroid = this.accuracyDataSource[districtName]['centroid'];
      this.districtWise = true;
      currentLoc = 'BLOCK';
    } else if (locType == 'Mandal') {
      this.selectedMandal = this.accuracyDataSource[districtName][locType].val;
      this.districtWise = true;
      this.mandalWise = true;
      this.mandalUUIDAcc = this.accuracyDataSource[districtName]['centroid'];
      currentLoc = 'VILLAGE'
    } else if (locType == 'Village') {
      this.accuracyHeaders =  this.acctabledata['columns'];
      this.accuracyHeadersColumns = this.acctabledata['tableHeaders'];
      this.accuracyDataSource = this.sortAsc(this.acctabledata['data'], this.accuracyHeadersColumns[0]['val']);
      this.districtWise = true;
      this.mandalWise = true;
      currentLoc = 'VILLAGE'
    }
    // console.log("select", this.selectedDistrict, locType, this.accuracyDataSource)
    if(locType !== 'Village') {
      this.accuracymandalclicked.emit({
        locType: locType,
        locUUID: this.accuracyDataSource[districtName][locType].id,
        current: currentLoc
      });
    }
    const mapDistrict = {
      loc: this.accuracyDataSource[districtName][locType].val,
      centroid: this.accuracyDataSource[districtName]['centroid']
    };
    mapDistrict['locType'] = locType;
    this.utils.districtClicked.next(mapDistrict);
    this.utils.thresholdMap.next({});
    this.obj.resetLayerStyle();
  }

  accuracyrowclicked() {
    this.accuracytableclicked.emit(this.selectedDate['value']);
  }

  zoomToMandal(districtName: string | number, locType: string | number) {
    const mapDistrict = {
      loc: this.dataSource3[districtName][locType].val,
      centroid: this.dataSource3[districtName]['centroid'],
      zoomLevel : 10
    };
    mapDistrict['locType'] = locType;
    this.utils.districtClicked.next(mapDistrict);
  }
  zoomToStates(stateName: string | number, locType: string | number) {
    const mapDistrict = {
      loc: this.dataSource4[stateName][locType].val,
      centroid: this.dataSource4[stateName]['centroid']
    };
    mapDistrict['locType'] = locType;
    this.utils.districtClicked.next(mapDistrict);
  }
  zoomToDistricts(stateName: string | number, locType: string | number) {
    const mapDistrict = {
      loc: this.dataSource3[stateName][locType].val,
      centroid: this.dataSource3[stateName]['centroid']
    };
    mapDistrict['locType'] = locType;
    this.utils.stateClicked.next(mapDistrict);
  }

  zoomToVillageTable(districtName: string | number, locType: string | number) {
    const mapMandal = {
      loc: this.villageData[districtName][locType].val,
      centroid: this.villageData[districtName]['centroid']
    };
    mapMandal['locType'] = locType;
    this.utils.districtClicked.next(mapMandal);
  }

  zoomToMandals(districtName: string | number, locType: string | number) {
    const mapDistrict = {
      loc: this.dataSource1[districtName][locType].val,
      centroid: this.dataSource1[districtName]['centroid']
    };
    mapDistrict['locType'] = locType;
    this.utils.districtClicked.next(mapDistrict);
  }

  changeToDistrictView(disManView) {
    if(disManView == 'District') {
      // if (this.show) {
      //   if (this.locationObj == null || this.locationObj.locType !== 'State') {
      //     this.threshold = '';
      //     this.utils.thresholdMap.next({});
      //     // this.obj.resetLayerStyle();   //need to change later
      //   }
      // }
      this.districtWise = true;
      this.mandalWise = false;
      this.stateWise=false;
      this.vilthrobber = false;
      this.levelData = 'District';
      this.isVillageLevel.emit({
        village: false
      });
      const locClick = {
        locType: 'District',
        loc: this.selectedDistrict,
        centroid: this.districtCentroid,
        // zoomLevel: ProjConstants[this.stateName + '_ZOOM_LEVEL']
      };
      this.utils.districtClicked.next(locClick);
      if (this.stateName != 'ANDHRA PRADESH') {
        this.sortA(this.dataSource, this.displayedColumns[0][0].val);
      }
      this.accuracymandalclicked.emit({
        locType: 'State',
        locUUID: this.utils.getStateUUID(this.route.snapshot.paramMap.get('id')),
        current: 'DISTRICT'
      });
    } else if(disManView=='State') {
      this.tableThrobberDistricts = true;
      this.chartThrobber = true;
      this.displayLevelWiseTable = 'No of Districts';
      this.districtWise = true;
      this.adminSelected =true
      this.mandalWise = false;
      this.stateWise=false;
      this.vilthrobber = false;
      this.showChartTableToggle = true
      this.levelData = 'State';
      this.isVillageLevel.emit({
        village: false
      });
      const locClick = {
        loc: this.selectedState,
        centroid: this.stateCentroid,
        zoomLevel : 7,
        uuid : this.stateUUId
      };
      locClick['locType']= 'State'
      this.utils.districtClicked.next(locClick);
      this.utils.setDistrictClicked(locClick);
      this.utils.setBreadcrumbClick('State')
      this.utils.thresholdMap.next({});
      this.stateSelected.emit({
        state: this.selectedState,
        stateUUID: this.stateUUId,
        mandal: true
      });
      this.accuracymandalclicked.emit({
        locType: 'BLOCK',
        locUUID: this.currentlocUUID,
        current: 'BLOCK'
      });
    }
     if(disManView=='Country') {
      this.loading = false;
      this.chartThrobber = false;
      this.showChartTableToggle = true
      this.displayLevelWiseTable = 'No of States';
      this.utils.setCountryClicked(true)
      this.districtWise = false;
      this.mandalWise = false;
      this.stateWise=true;
      this.vilthrobber = false;
      this.levelData = 'Country';
      this.isVillageLevel.emit({
        village: false
      });
      const locClick = {
        loc: 'India',
        centroid: {lat : 20.5937, lon:78.9629},
        zoomLevel :5
      };
      locClick['locType'] = 'Country'
      this.utils.districtClicked.next(locClick);
      this.utils.setDistrictClicked(locClick);
      this.utils.setBreadcrumbClick('Country')
      // this.utils.setDistrictClicked(locClick)
    }
  }

  capitalize(string: string) {
    if (string == null || string == undefined) {
      return ' ';
    }
    const string1 = string.toLowerCase();
    const capitalized = string1[0].toUpperCase() + string1.slice(1);
    return capitalized;
  }

  getColor(value: string) {
    if (this.componentName == 'RAINFALL') {
      this.header = 'Rainfall Band';
      for (const category of ProjConstants.RAINFALL_CATEGORIES_ARRAY) {
        if (value == category) {
          return ProjConstants.RAINFALL_CHART_RANGE_TO_COLOR_MAPPING[category];
        }
      }
    }
    // if (this.componentName == 'RAINFALL' && this.currentForecastLength=='weekly') {
    //   this.header = 'Rainfall Band';
    //   for (const category of ProjConstants.RAINFALL_CATEGORIES_ARRAY_WEEKLY) {
    //     if (value == category) {
    //       return ProjConstants.RAINFALL_CHART_RANGE_TO_COLOR_MAPPING_WEEKLY[category];
    //     }
    //   }
    // }
    if (this.componentName == 'TEMPERATURE') {
      this.header = 'Temperature Band';
      for (const category of ProjConstants.TEMPERATURE_CATEGORIES_ARRAY) {
        const lowerValue = category.split('-')[0];
        if (value.split('-')[0] == lowerValue) {
          if (category != '>=46') {
            return ProjConstants.TEMPERATURE_CHART_RANGE_TO_COLOR_MAPPING[lowerValue];
          } else {
            return ProjConstants.TEMPERATURE_CHART_RANGE_TO_COLOR_MAPPING['>46'];
          }
        }
        // else {
        //   return ProjConstants.TEMPERATURE_CHART_RANGE_TO_COLOR_MAPPING['46'];
        // }
      }
    }
    if (this.componentName == 'HUMIDITY') {
      this.header = 'Humidity Band';
      for (const category of ProjConstants.HUMIDITY_RANGES_ARRAY) {
        if (value == category.split('-')[0]) {
          return ProjConstants.HUMIDITY_CHART_RANGE_TO_COLOR_MAPPING[category];
        }
      }
    }

    if (this.componentName == 'WINDSPEED') {
      this.header = 'Wind Speed Band';
      for (const category of ProjConstants.WINDSPEED_CATEGORIES_ARRAY) {
        if (value == category) {
          return ProjConstants.WINDSPEED_CHART_RANGE_TO_COLOR_MAPPING[category];
        }
      }
    }

    if (this.componentName == 'HEATINDEX') {
      this.header = 'Heat Index Band';
      for (const category of Object.keys(ProjConstants.HEAT_INDEX_LEGEND)) {
        if (value == category) {
          return { 'background-color': ProjConstants.HEAT_INDEX_LEGEND  [category] };
        }
      }
    }

    if (this.componentName == 'HEATWATCHES') {
      this.header = 'Heat Watches Band';
      for (const category of Object.keys(ProjConstants.HEAT_WATCHES_LEGEND)) {
        if (value == category) {
          return { 'background-color': ProjConstants.HEAT_WATCHES_LEGEND[category] };
        }
      }
    }

    if (this.componentName == 'HEATWAVE') {
      this.header = 'Heat Wave Band';
      for (const category of Object.keys(ProjConstants.HEAT_WATCHES_LEGEND)) {
        if (value == category) {
          return { 'background-color': ProjConstants.HEAT_WATCHES_LEGEND[category] };
        }
      }
    }
    if (this.componentName == 'COLDWAVE') {
      this.header = 'Cold Wave Band';
      for (const category of Object.keys(ProjConstants.COLD_WATCHES_LEGEND_CHART)) {
        if (value == category) {
          return { 'background-color': ProjConstants.COLD_WATCHES_LEGEND_CHART[category] };
        }
      }
    }

    if (this.componentName == 'DISCOMFORTINDEX') {
      this.header = 'Discomfort Index Band';
      value = value.split(" ").join("_").toLowerCase();
      for (const category of Object.keys(ProjConstants.DISCOMFORT_INDEX_LEGEND)) {
        if (value == category) {
          return { 'background-color': ProjConstants.DISCOMFORT_INDEX_LEGEND[category] };
        }
      }
    }
    // if (this.componentName == 'NOWCAST') {
    //   this.header = 'Nowcast Band';
    //   value = value.split(" ").join("_").toLowerCase();
    //   for (const category of Object.keys(ProjConstants.DISCOMFORT_INDEX_LEGEND)) {
    //     if (value == category) {
    //       return { 'background-color': ProjConstants.DISCOMFORT_INDEX_LEGEND[category] };
    //     }
    //   }
    // }
  }

  sortA(data: string | any[], columnName: string | number) {
    // function to sort dataTable
    // if (data == this.dataSource) {
    //   this.dataSource = data;
    // }
    if(columnName != 'District'){
      let i: number, j: number;
      const key = {};
      for (i = 1; i < data.length; i++) {
        Object.assign(key, data[i]);
        j = i - 1;
        let oldVal = data[j][columnName].val;
        let newVal = key[columnName].val;
        if (!isNaN(oldVal) && !isNaN(newVal)) {
          oldVal = Number(oldVal);
          newVal = Number(newVal);
        }
        while (j >= 0 && (oldVal > newVal)) {
          Object.assign(data[j + 1], data[j]);
          j = j - 1;
          if (j >= 0) {
            oldVal = data[j][columnName].val;
            newVal = key[columnName].val;
            if (!isNaN(oldVal) && !isNaN(newVal)) {
              oldVal = Number(oldVal);
              newVal = Number(newVal);
            }
          }
        }
        Object.assign(data[j + 1], key);
      }
    }
  }

  sortAscDes(data: any, columnName: any) {
    console.log(data,columnName,"columnname")
    if (this.flagSort) {
      this.sortD(data, columnName);
      this.flagSort = false;
    } else {
      this.sortA(data, columnName);
      this.flagSort = true;
    }
  }

  sortD(data: string | any[], columnName: string | number) {
    // function to sort dataTable
    // if (data == this.dataSource) {
    //   this.dataSource = data;
    // }
    let i: number, j: number;
    const key = {};
    for (i = 1; i < data.length; i++) {
      Object.assign(key, data[i]);
      j = i - 1;
      let oldVal = data[j][columnName].val;
      let newVal = key[columnName].val;
      if (!isNaN(oldVal) && !isNaN(newVal)) {
        oldVal = Number(oldVal);
        newVal = Number(newVal);
      }
      while (j >= 0 && (oldVal < newVal)) {
        Object.assign(data[j + 1], data[j]);
        j = j - 1;
        if (j >= 0) {
          oldVal = data[j][columnName].val;
          newVal = key[columnName].val;
          if (!isNaN(oldVal) && !isNaN(newVal)) {
            oldVal = Number(oldVal);
            newVal = Number(newVal);
          }
        }
      }
      Object.assign(data[j + 1], key);
    }
  }

  validForecastFile(date: string | any[]) {
    let returnString = '';
    if (date != null && date != undefined) {
      if (date.length == 10) {
        const Year = date[0] + date[1] + date[2] + date[3];
        const Month = date[4] + date[5];
        const DayOfMonth = date[6] + date[7];
        // let hours = (Number(date[8] + date[9])) % 24;
        let hours = (this.sourcevalue=='IMD'?((Number(date[8] + date[9])) % 24)+3:((Number(date[8] + date[9])) % 24));
        let amPm = 'A.M';
        if (hours > 12) {
          hours = hours - 12;
          amPm = 'P.M';
        }
        hours = hours + 5;
        const currDate = new Date(Year + '-' + Month + '-' + DayOfMonth);
        // returnString = hours.toString() + ':30' + amPm + ' ( ' + currDate.toLocaleDateString('en-GB', {
        //   day: 'numeric', month: 'short', year: 'numeric'
        // }).replace(/ /g, '-') + ' GMT+05:30 ) ';
        returnString = currDate.toLocaleDateString('en-GB', {
          day: 'numeric', month: 'short', year: 'numeric'
        }).replace(/ /g, '-') + ' GMT+05:30';
      }
    }
    this.utils.setLastProcessedTime(returnString)
    return returnString;
  }

  // sortAPDistrictsByGeo(tableDataa) {
  //   let dataSorted = {};
  //   //this.tableDataa
  //   for(let dist of ProjConstants.AP_DISTRICT_ORDER){
  //     let keys = Object.keys(tableDataa);
  //     for(let data in tableDataa) {
  //       if(dist == keys[data]){
  //         dataSorted[dist] = tableDataa[dist];
  //       }
  //     }
  //   }
  //   console.log("Sorted data is : ", dataSorted);
  //   this.tableDataa = dataSorted;
  // }

  validate(data: any) {
    if (data == null || data == undefined) {
      return '';
    }
    return data;
  }

  // getCurrTime() {
  //   return new Date();
  // }

  getUnits() {
    if (this.componentName === 'SEAMLESSRAINFALL' || this.componentName === 'RAINFALL') {
      return '( mm/hr )';
    } else if (this.componentName == 'HEATINDEX' || this.componentName=='COLDWAVE' || this.componentName == 'HEATWAVE' || this.componentName == 'HEATWATCHES' || this.componentName == 'DISCOMFORTINDEX') {
      if (this.show && this.stateWise) {
        return '(No of District)';
      } else if (this.show && !this.mandalWise) {
        return '( No of Mandals)';
      } else {
        return '( °C )';
      }
    } else if (this.componentName === 'NOWCAST') {
      return '';
    } else {
      return '( ' + this.componentUnitMapping[this.componentName] + ' )';
    }
  }
  sortAPDistricts(tableDataa: { [s: string]: unknown; } | ArrayLike<unknown>) {
    let dataSorted = [];
    //this.tableDataa
    for (let dist of ProjConstants.AP_DISTRICT_ORDER) {
      Object.values(tableDataa).forEach(valu => {
        if (dist == valu['District']['val']) {
          dataSorted.push(valu);
        }
      });
    }
    tableDataa = dataSorted;
    return tableDataa;
  }

  sortAsc(tableData: any[], locType?:any) {
    tableData.sort((a: { [x: string]: { [x: string]: number; }; }, b: { [x: string]: { [x: string]: number; }; }) => (a[locType]['val'] > b[locType]['val']) ? 1 : -1);
    this.flagSort = true;
    return tableData;
  }

  getkeys(data: {}) {
    return Object.keys(data).reverse();
  }

  exportexcel() {
    const element = document.getElementById('gis-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    if (this.selectedComponent == 'seamlessrainfall') {
      this.selectedSource = 'IMD';
    }
    if (this.selectedSource == 'IMD_LONG_RANGE') {
      this.selectedSource = 'IMD';
    }
    const units = this.getUnits();
    let sourceText: any;
    if (this.selectedComponent != 'coldwave' && this.selectedComponent != 'heatindex') {
      sourceText = ['Source: ' + this.selectedSource + ' ' + units];
    }
    if (this.selectedComponent == 'heatwave' ) {
      sourceText = ['Source: ' + this.selectedSource];
    }
    if ( this.selectedComponent == 'seamless-view') {
        sourceText = ['Source: ' + SeamlessViewMapConstants.SOURCE_MAPPING_1[this.selectedSource]];
    }
    if (this.selectedComponent == 'nowcast') {
      sourceText = ['Source: ' + this.selectedSource + ' (mm/hr)'];
    }
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const newWs: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([sourceText, []]);
    const originalData = XLSX.utils.sheet_to_json(ws, { header: 1 }) as string[][];
    XLSX.utils.sheet_add_aoa(newWs, originalData, { origin: 'A3' });
    XLSX.utils.book_append_sheet(wb, newWs, 'Sheet1');
    let fileName: any;
    if (this.selectedComponent == 'coldwave' || this.selectedComponent == 'heatindex') {
      fileName = `${this.selectedComponent}.xlsx`;
    } else if (this.selectedComponent == 'seamless-view') {
      fileName = `${this.selectedComponent}_${SeamlessViewMapConstants.SOURCE_MAPPING_FILE[this.selectedSource]}.xlsx`;
    } else {
      fileName = `${this.selectedComponent}_${this.selectedSource}.xlsx`;
    }
    XLSX.writeFile(wb, fileName);
  }

  enableMapInteractionOnClickTopLeft() {
    this.enableMapInteractionObject['2.5'] = true;
  }

  enableMapInteractionOnClickTopRight() {
    this.enableMapInteractionObject['15.6'] = true;
  }

  enableMapInteractionOnClickBottomLeft() {
    this.enableMapInteractionObject['64.5'] = true;
  }

  enableMapInteractionOnClickBottomRight() {
    this.enableMapInteractionObject['115.6'] = true;
  }

  getAccuracy() {
    this.accEnabled = !this.accEnabled;
    this.changeToDistrictView('District');
  }

  createThresholdMapTable() {
    this.thresholdMap = {};
    const appType = this.router.url.split('/')[1];
    const timeType = parseInt(this.router.url.split('/')[3], 10);
    if (appType === 'extremeweather') {
      if (timeType === 24) {
        if (this.componentName === 'WINDSPEED') {
          if (!this.show) {
            if (!this.adminSelected) {
              this.thresholdMap['type'] = 'Sub-basin View';
            } else {
              this.thresholdMap['type'] = 'Mandal View';
            }
            // this.obj.changeTimeLayers(this.columnTable);
            Object.keys(this.dataSource1).forEach((key: any) => {
              this.thresholdMap[this.dataSource1[key].uuid] = [];
              for (let i = 0; i <= 3; ++i) {
                if (this.obj.initialCounter + (i * 21600000)==this.columnTable && Number(this.dataSource1[key][(this.obj.initialCounter + (i * 21600000))].val.split(' ')[0]) >= this.thresholdMin && Number(this.dataSource1[key][(this.obj.initialCounter + (i * 21600000))].val.split(' ')[0]) <= this.thresholdMax) {
                  this.thresholdMap[this.dataSource1[key].uuid].push(1);
                  // console.log("here", (this.obj.initialCounter + (i * 21600000)), this.thresholdMap[this.dataSource1[key].uuid])
                } else {
                  this.thresholdMap[this.dataSource1[key].uuid].push(0);
                }
              }
            });
          }
        } else if (this.componentName === 'RAINFALL' || this.componentName === 'TEMPERATURE' || this.componentName === 'HUMIDITY') {
          if (!this.show) {
            if (!this.adminSelected) {
              this.thresholdMap['type'] = 'Sub-basin View';
            } else {
              this.thresholdMap['type'] = 'Mandal View';
            }
            Object.keys(this.dataSource1).forEach((key: any) => {
              this.thresholdMap[this.dataSource1[key].uuid] = [];
              for (let i = 0; i <= 3; ++i) {
                if (this.obj.initialCounter + (i * 21600000)==this.columnTable && Number(this.dataSource1[key][(this.obj.initialCounter + (i * 21600000))].val.split(' ')[0]) >= this.thresholdMin && Number(this.dataSource1[key][(this.obj.initialCounter + (i * 21600000))].val.split(' ')[0]) <= this.thresholdMax) {
                  this.thresholdMap[this.dataSource1[key].uuid].push(1);
                } else {
                  this.thresholdMap[this.dataSource1[key].uuid].push(0);
                }
              }
              if (this.columnTable == '24hr' && Number(this.dataSource1[key]['24hr'].val.split(' ')[0]) >= this.thresholdMin && Number(this.dataSource1[key]['24hr'].val.split(' ')[0]) <= this.thresholdMax) {
                this.thresholdMap[this.dataSource1[key].uuid].push(1);
              } else {
                this.thresholdMap[this.dataSource1[key].uuid].push(0);
              }
            });
          }
        }
      } else if (timeType === 10) {
        if (this.componentName === 'WINDSPEED') {
          let counter = this.obj.initialCounter;
          const currDate = new Date();
          const date1 = new Date();
          date1.setHours(5, 30, 0);
          const date2 = new Date();
          date2.setHours(11, 30, 0);
          const date3 = new Date();
          date3.setHours(17, 30, 0);
          const date4 = new Date();
          date4.setHours(23, 30, 0);
          if (currDate >= date1 && currDate < date2) {
            counter -= (21600000 * 0);
          } else if (currDate >= date2 && currDate < date3) {
            counter -= (21600000 * 1);
          } else if (currDate >= date3 && currDate < date4) {
            counter -= (21600000 * 2);
          } else {
            counter -= (21600000 * 3);
          }
          if (!this.show) {
            if (!this.adminSelected) {
              this.thresholdMap['type'] = 'Sub-basin View';
            } else {
              this.thresholdMap['type'] = 'Mandal View';
            }
            Object.keys(this.dataSource1).forEach((key: any) => {
              this.thresholdMap[this.dataSource1[key].uuid] = [];
              for (let i = 0; i <= 6; ++i) {
                if (Number(this.dataSource1[key][(counter + (i * 86400000))].val.split(' ')[0]) >= this.thresholdMin && Number(this.dataSource1[key][(counter + (i * 86400000))].val.split(' ')[0]) <= this.thresholdMax) {
                  this.thresholdMap[this.dataSource1[key].uuid].push(1);
                } else {
                  this.thresholdMap[this.dataSource1[key].uuid].push(0);
                }
              }
            });
          }
        } else if (this.componentName === 'RAINFALL' || this.componentName === 'TEMPERATURE' || this.componentName === 'HUMIDITY') {
          if (!this.show) {
            if (!this.adminSelected) {
              this.thresholdMap['type'] = 'Sub-basin View';
            } else {
              this.thresholdMap['type'] = 'Mandal View';
            }
            Object.keys(this.dataSource1).forEach((key: any) => {
              this.thresholdMap[this.dataSource1[key].uuid] = [];
              for (let i = 0; i <= 6; ++i) {
                if (Number(this.dataSource1[key][(this.obj.initialCounter + (i * 86400000))].val.split(' ')[0]) >= this.thresholdMin && Number(this.dataSource1[key][(this.obj.initialCounter + (i * 86400000))].val.split(' ')[0]) <= this.thresholdMax) {
                  this.thresholdMap[this.dataSource1[key].uuid].push(1);
                } else {
                  this.thresholdMap[this.dataSource1[key].uuid].push(0);
                }
              }
            });
          }
        }
      }
      this.utils.thresholdMap.next(this.thresholdMap);
      if(this.columnTable == '24hr' && this.component == 'WINDSPEED') {
        this.thresholdMap = {};
        this.utils.thresholdMap.next({});
        this.obj.changeLayerStyleforThreshold();
      }
      if(this.columnTable==='24hr') {
        if(this.componentName === 'RAINFALL' || this.componentName === 'TEMPERATURE' || this.componentName === 'HUMIDITY')
          this.obj.changeTimeLayers(this.columnTable)
      } else {
        this.obj.changeTimeLayers(this.columnTable)
      }
      // this.obj.changeTimeLayers(this.columnTable)
    }
  }

  gethighlight(col, data, row, index) {
    this.show = false;
    this.columnTable = col;
    this.thresholdMin = '';
    this.thresholdMax = '';
    if (this.componentName == 'RAINFALL') {
      for (const category of ProjConstants.RAINFALL_CATEGORIES_ARRAY) {
        if (row == category) {
          data = ProjConstants.RAINFALL_CHART_RANGE_TO_DATA_MAPPING[category];
        }
      }
      row = data;
    }
    if (this.componentName == 'HUMIDITY') {
      for (const category of ProjConstants.HUMIDITY_RANGES_ARRAY) {
        if (row == category) {
          data = ProjConstants.HUMIDITY_CHART_RANGE_TO_DATA_MAPPING[category];
        }
      }
      row = data;
    }
    if (/^[0-9]*-[0-9]*$/.test(row) || /^[0-9]+(\.[0-9])*-[0-9]+(\.[0-9])?$/.test(row)) {
      this.thresholdMin = row.split("-")[0];
      this.thresholdMax = row.split("-")[1];
    } else if (/^>=[0-9]*$/.test(row) || /^>=[0-9]+(\.[0-9])*$/.test(row)) {
      this.thresholdMin = row.split("=")[1];
      this.thresholdMax = 1000;
    } else if (/^<[0-9]*$/.test(row)) {
      this.thresholdMin = -20;
      this.thresholdMax = row.split("<")[1];
    }
    setTimeout(() => {
      let len = this.headerColumns1.length;
      if(!this.show) {
        this.tcells = document.getElementsByName('tcell');
        for (const i of this.tcells) {
          i.classList.remove(ProjConstants.THRESHOLD_COLOR);
        }
        let i;
        for (i=index+1 ; i<this.tcells.length ; i=i+len) {
          if (this.component !== 'TEMPERATURE' && Number(this.tcells[i].textContent) >= this.thresholdMin && Number(this.tcells[i].textContent) <= this.thresholdMax) {
            this.tcells[i].classList.add(ProjConstants.THRESHOLD_COLOR);
          }  else if (this.component === 'TEMPERATURE') {
            if (Number(this.tcells[i].textContent.toString().split(' ')[0]) >= this.thresholdMin && Number(this.tcells[i].textContent.toString().split(' ')[0]) <= this.thresholdMax) {
              this.tcells[i].classList.add(ProjConstants.THRESHOLD_COLOR);
            }
          }
        }
        this.createThresholdMapTable();
      }
    }, 1000);
  }

  fixTo(x,y){
    return parseFloat(x).toFixed(y);
  }


  openPopup(title:string){
    const modalRef = this.modalService.open(AccuracyPopupDataTableComponent, {
      size: 'lg',
      centered: true,
      windowClass: 'modal-dark size-large',
      backdrop: 'static'
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.selectedState = this.selectedState
    modalRef.componentInstance.stateUUID = this.stateUUId
    modalRef.componentInstance.locType = this.levelData
  }

}
